import { Link } from 'react-router-dom'
import { periodicityLabels, priorityLabels, sourceLabels, statusLabels, taskTitleClass } from '../../domain/taskRules'
import { formatDueDateTime } from '../../lib/time'
import type { TaskDashboard } from '../../types/domain'

const priorityStyles = {
  normal: 'bg-blue-100 text-blue-800',
  urgent: 'bg-rose-100 text-rose-800',
}

function TaskCard({ task }: { task: TaskDashboard }) {
  const deadlineClass = task.archived_at || task.status === 'completed'
    ? 'task-card-neutral'
    : task.is_overdue
      ? 'task-card-overdue'
      : 'task-card-on-time'
  return (
    <li>
      <Link
        className={`card block p-4 transition hover:-translate-y-0.5 hover:shadow-lg sm:p-5 ${deadlineClass}`}
        to={`/tarefas/${task.id}`}
      >
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <h3 className={`truncate text-lg font-extrabold ${taskTitleClass(task)}`}>{task.title}</h3>
            <p className="mt-1 text-sm text-slate-600">{task.client_name} · {task.assignee_name} · {task.department_name}</p>
          </div>
          <span className={`rounded-full px-2.5 py-1 text-xs font-extrabold ${priorityStyles[task.priority]}`}>
            {priorityLabels[task.priority]}
          </span>
        </div>
        <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-sm">
          <span className="font-semibold text-slate-700">{statusLabels[task.status]}</span>
          <span className="text-slate-600">{sourceLabels[task.source]}</span>
          {task.periodicity !== 'none' ? <span className="text-slate-600">{periodicityLabels[task.periodicity]}</span> : null}
          <span className={task.is_overdue ? 'font-extrabold text-red-700' : task.is_due_soon ? 'font-extrabold text-amber-700' : 'text-slate-600'}>
            Prazo: {formatDueDateTime(task.due_date, task.due_time)}
          </span>
        </div>
      </Link>
    </li>
  )
}

export function TaskList({ title, tasks, emptyMessage }: { title: string; tasks: TaskDashboard[]; emptyMessage: string }) {
  return (
    <section aria-labelledby={`group-${title.replace(/\s/g, '-').toLowerCase()}`}>
      <div className="mb-3 flex items-center gap-2">
        <h2 className="text-xl font-extrabold text-slate-900" id={`group-${title.replace(/\s/g, '-').toLowerCase()}`}>{title}</h2>
        <span className="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-extrabold text-slate-700">{tasks.length}</span>
      </div>
      {tasks.length ? (
        <ul className="grid gap-3">{tasks.map((task) => <TaskCard key={task.id} task={task} />)}</ul>
      ) : (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white/60 p-5 text-slate-500">{emptyMessage}</div>
      )}
    </section>
  )
}
